var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLargeWire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 45C6 42.7909 7.79086 41 10 41H116C118.209 41 120 42.7909 120 45V89C120 91.2091 118.209 93 116 93H10C7.79086 93 6 91.2091 6 89V45Z",
    fill: "url(#paint0_linear_5588_25751)",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 42.3449C100 50.4387 105.939 57 113.265 57C115.723 57 118.026 56.2609 120 54.9729L120 45C120 42.7909 118.209 41 116 41L101.402 41C100.641 41 100 41.5841 100 42.3449Z",
    fill: "url(#paint1_linear_5588_25751)",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 91.6551C26 83.5613 20.0612 77 12.7353 77C10.2766 77 7.97415 77.7391 6 79.0271L6 89C6 91.2091 7.79086 93 10 93L24.5984 93C25.3593 93 26 92.4159 26 91.6551Z",
    fill: "url(#paint2_linear_5588_25751)",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100 91.6551C100 83.5613 105.939 77 113.265 77C115.723 77 118.026 77.7391 120 79.0271L120 89C120 91.2091 118.209 93 116 93L101.402 93C100.641 93 100 92.4159 100 91.6551Z",
    fill: "url(#paint3_linear_5588_25751)",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 42.3449C26 50.4387 20.0612 57 12.7353 57C10.2766 57 7.97414 56.2609 6 54.9729L6 45C6 42.7909 7.79086 41 10 41L24.5984 41C25.3593 41 26 41.5841 26 42.3449Z",
    fill: "url(#paint4_linear_5588_25751)",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 66,
    r: 20,
    fill: "url(#paint5_linear_5588_25751)",
    fillOpacity: 0.41,
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 57.3C58.4624 57.3 56 59.3595 56 61.9C56 64.4405 57.8333 66.5 61.5 66.5C65.1667 66.5 67 68.5595 67 71.1C67 73.6405 64.5376 75.7 61.5 75.7M61.5 57.3C63.5357 57.3 65.3132 58.2251 66.2642 59.6M61.5 57.3V55M61.5 75.7L61.5 78M61.5 75.7C59.4643 75.7 57.6868 74.7749 56.7358 73.4",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 45C6 42.7909 7.79086 41 10 41H116C118.209 41 120 42.7909 120 45V89C120 91.2091 118.209 93 116 93H10C7.79086 93 6 91.2091 6 89V45Z",
    stroke: "url(#paint6_linear_5588_25751)",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.173 77.7135L119.155 66.6857C117.643 65.1727 115.057 66.2433 115.057 68.382V72.7487V74.6858H76.4C75.0745 74.6858 74 75.7603 74 77.0858V83.0932C74 84.4187 75.0745 85.4932 76.4 85.4932H115.057V87.1585V90.4376C115.057 92.5763 117.643 93.6469 119.155 92.1339L130.173 81.1061C131.109 80.169 131.109 78.6506 130.173 77.7135Z",
    fill: "#0E5CF4",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5588_25751",
    x1: 61,
    y1: 41,
    x2: 61,
    y2: 93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5CCDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5588_25751",
    x1: 106.008,
    y1: 53.1514,
    x2: 115.073,
    y2: 41.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5588_25751",
    x1: 19.9921,
    y1: 80.8486,
    x2: 10.9266,
    y2: 92.5755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5588_25751",
    x1: 106.008,
    y1: 80.8486,
    x2: 115.073,
    y2: 92.5755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5588_25751",
    x1: 19.9921,
    y1: 53.1514,
    x2: 10.9266,
    y2: 41.4245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5588_25751",
    x1: 62,
    y1: 70.5,
    x2: 62,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8CFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5588_25751",
    x1: 3,
    y1: 42.5,
    x2: 118.5,
    y2: 93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLargeWire);
export default __webpack_public_path__ + "static/media/ic-large-wire.e56945e621a2b58421a0161bc84ec8ed.svg";
export { ForwardRef as ReactComponent };